import React, { useState, useEffect } from "react";

import * as Constant from "../../../Constant.js";

import axios from "@app/lib/axios";
import * as commonData from "@app/lib/common_data";

const ContractStatSummary = ({ branch_id, year, serviceAppList, appAuthTypeList, selectedAppContractType, setSelectedAppContractType }) => {
    const [loadingData, setLoadingData] = useState(true);

    const [data, setData] = useState({
        bizAppList: [],
        stats: {},
        statsUnion: {}
    });

    useEffect(() => {
        if (loadingData && appAuthTypeList) {
            getData(branch_id, year);
        }
        return () => {};
    }, [branch_id, year, selectedAppContractType, appAuthTypeList]);

    const getData = (branch_id, year) => {
        setLoadingData(true);
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/contract/stat/summary/${branch_id}?year=${year || new Date().getFullYear()}`,
        })
            .then((res) => {
                const result = res.data;
                const _data = { ...data };
                _data.bizAppList = result.bizApp || [];
                _data.stats = {};
                _data.statsUnion = {};
                if (_data.bizAppList && _data.bizAppList.length > 0) {
                    _data.bizAppList.forEach((app) => {
                        const stats = result.stats.filter((s) => s.app_id == app);
                        if (stats && stats.length > 0) {
                            stats.forEach((s) => {                                    
                                if (!s.authType) {
                                    if(_data.stats[s.app_id]) {
                                        Object.keys(s).forEach((k) => _data.stats[s.app_id][k] += (s[k] || 0));
                                    } else {
                                        _data.stats[s.app_id] = s;
                                    }
                                }                     
                                if (s.authType) {
                                    _data.statsUnion[`${s.app_id}_${s.authType}`] = s;
                                }
                            });
                        }
                    });
                }

                setData(_data);
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                setLoadingData(false);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const onSelectAppContractType = (app_id, contract_type) => {
        const newSelectedAppContractType = {
            app_id: app_id == selectedAppContractType.app_id && contract_type == selectedAppContractType.contract_type ? null : app_id,
            contract_type: app_id == selectedAppContractType.app_id ? (contract_type == selectedAppContractType.contract_type ? null : contract_type) : contract_type,
        };
        setSelectedAppContractType(newSelectedAppContractType);
    };

    return (
        <>
            <div className="row">
                <div className="col">
                    &lt;서비스 별 계약 현황&gt;
                    <div className="row">
                        {serviceAppList && serviceAppList.map((sa) => {
                            if(sa.contractUseTas && data.bizAppList.indexOf(sa.key) > -1) {
                                return (
                                    <div className={`col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12`}>
                                        <CommonSummaryTable
                                            name={sa.name}
                                            app={sa.key}
                                            year={year}
                                            appAuthTypeList={appAuthTypeList}
                                            data={data.stats[sa.key]}
                                            cssClass={'bg-summary-app'}
                                            selectedAppContractType={selectedAppContractType}
                                            onSelectAppContractType={onSelectAppContractType}
                                        />
                                    </div>);
                            } else {
                                return null;
                            }
                        })}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    &lt;결합상품 별 계약 현황&gt;
                    <div className="row">
                        {appAuthTypeList && appAuthTypeList.all.map((sa) => {
                            return (
                                <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12">
                                    <CommonSummaryTable
                                        app={`${sa.appId}_${sa.type}`}
                                        name={sa.name}
                                        year={year}
                                        appAuthTypeList={appAuthTypeList}
                                        data={data.statsUnion[`${sa.appId}_${sa.type}`]}
                                        selectedAppContractType={selectedAppContractType}
                                        cssClass={'bg-summary-union'}
                                    />
                                </div>);
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

const CommonSummaryTable = ({ app, name, year, data, selectedAppContractType, onSelectAppContractType, cssClass }) => {
    const [stat, setStat] = useState(
        data || {
            new: 0,
            renew: 0,
            next: 0,
            new_q: 0,
            renew_q: 0,
            next_q: 0,
        }
    );

    useEffect(() => {
        setStat(
            data || {
                new: 0,
                renew: 0,
                next: 0,
                new_q: 0,
                renew_q: 0,
                next_q: 0,
            }
        );
        return () => {};
    }, [year, data]);

    return (
        <div className="card mb-3">
            <div className="card-body p-0">
                <table className="table table-bordered table-branch-contract-summary">
                    <thead>
                        <tr className={``} onClick={() => onSelectAppContractType ? onSelectAppContractType(app, null) : ''}>
                            <th className={`${cssClass} text-white`} style={{ verticalAlign: "top" }}>
                                {name}
                            </th>
                            <th className={`${cssClass}-70`}>계정 수</th>
                            <th className={`${cssClass}-70`}>원아 수</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className={``} style={{lineHeight: '16px'}} onClick={() => onSelectAppContractType ? onSelectAppContractType(app, null) : ''}>
                            <th className="bg-light">전체</th>
                            <td className="text-danger text-right">
                                {(stat.new + stat.renew).toLocaleString()}<br/>({(stat.next || 0).toLocaleString()})
                            </td>
                            <td className="text-danger text-right">
                                {(stat.new_q + stat.renew_q).toLocaleString()}<br/>({(stat.next_q || 0).toLocaleString()})
                            </td>
                        </tr>
                        <tr
                            className={`${selectedAppContractType.app_id == app && selectedAppContractType.contract_type == "renew" ? "selected" : ""}`}
                            onClick={() => onSelectAppContractType ? onSelectAppContractType(app, 'renew') : ''}
                            style={{lineHeight: '12px'}}
                        >
                            <th className="bg-light" style={{whiteSpace: 'nowrap'}}>{year} 재계약</th>
                            <td className="text-right">{(stat.renew || 0).toLocaleString()}</td>
                            <td className="text-right">{(stat.renew_q || 0).toLocaleString()}</td>
                        </tr>
                        <tr
                            className={`${selectedAppContractType.app_id == app && selectedAppContractType.contract_type == "new" ? "selected" : ""}`}
                            onClick={() => onSelectAppContractType ? onSelectAppContractType(app, 'new') : ''}
                            style={{lineHeight: '12px'}}
                        >
                            <th className="bg-light">{year} 신규</th>
                            <td className="text-right">{(stat.new || 0).toLocaleString()}</td>
                            <td className="text-right">{(stat.new_q || 0).toLocaleString()}</td>
                        </tr>
                        <tr
                            className={`${selectedAppContractType.app_id == app && selectedAppContractType.contract_type == "next" ? "selected" : ""}`}
                            onClick={() => onSelectAppContractType ? onSelectAppContractType(app, 'next') : ''}
                            style={{lineHeight: '12px'}}
                        >
                            <th className="bg-light">{year + 1} 신규</th>
                            <td className="text-right">{(stat.next || 0).toLocaleString()}</td>
                            <td className="text-right">{(stat.next_q || 0).toLocaleString()}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ContractStatSummary;
